import _ from 'underscore';

import quotaTagHandlers from './quota'
import {Form} from '../form/form'
import FormGroup from '../form/formGroup'
import Variable from '../variable'

import {XmlTagInfo} from '../xmlTagProvider'
import {Options} from '../options'

// tag handlers for form, questionary model is passed as node.scope
var questionaryTagHandlers : { [xpath:string]: { (node: XmlTagInfo): any } } = {
	'questionary': node => {
		const content = _.groupBy(node.children, (n) => n.tag === 'options' ? 'options' : (n.tag === 'quotaList' ? 'quotas' : 'forms'));
		// TODO test that _rootFormGroup is FormGroup

		// Options may be missing, when no combo is present
		const optionsXml = _.isUndefined(content['options']) ? <XmlTagInfo>{ tag: "options", attributes: { }, children:[]} : content['options'][0];
		return {
			rootFormGroup: content['forms'][0],
			quotas: content['quotas'] ? content['quotas'][0] : null,
			options: Options.fromXML(optionsXml, node.scope!.questionary.messages)
		};
	},

	'formGroup': node => FormGroup.fromXML(node),
	'form': node => Form.fromXML(node),
	'variable': node => Variable.fromXML(node),
	'borders': node => {
		var borders = _.pluck(node.children, "tag");
		return {
			classes: () => _.reduce(borders, (res, cls) => res + " border-" + cls, ""),
			tag: 'borders'
		};
	},
	'cellSpan': node => ({
			x: parseInt(node.attributes['x']),
			y: parseInt(node.attributes['y']),
			width: parseInt(node.attributes['width']),
			height: parseInt(node.attributes['height'])
	})
};

_.extend(
	questionaryTagHandlers,
	quotaTagHandlers
);

export default questionaryTagHandlers;

